// Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
// Data
import itemsMenuAdmin from '../../../../data/menuAdmin';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// Actions
import { cargarContenido } from './actions/baroptionAction';
// Components
import MenuAdmin from '../MenuAdmin';
import OptionBar from './optionBar';

class TestWordPdf extends Component {
  static propTypes = {
    cargarContenido: PropTypes.func.isRequired,
    isLogged: PropTypes.bool.isRequired,
    nombreUser: PropTypes.string.isRequired,
    tipoUser: PropTypes.number.isRequired,
    optionSelected: PropTypes.string.isRequired
  };
  constructor(){
        super();
    }

  render() {
    const { isLogged, nombreUser, tipoUser, optionSelected } = this.props;
    const nivelRequired = 98;

    if(isLogged && nivelRequired <= tipoUser){
    return (
      <div className="inBodyMenu">
            <div className="menuBody">
              <MenuAdmin itemsMenu={itemsMenuAdmin} titleMenu="OPCIONES"/>
            </div>
            <div className="inBody">
                <div className="sectionBody">
                        <div className="optionsBar">
                          <div className="botonSmall" onClick={() => this.props.cargarContenido("Añadir_Test_Word")} >
                            <i className="fas fa-plus"></i>Añadir Test Word
                          </div>
                          <div className="botonSmall" onClick={() => this.props.cargarContenido("Editar_Test_Word")} >
                            <i className="fas fa-edit"></i>Editar/Borrar Test Word
                          </div>
                        </div>
                        <div className="optionselected">
                          <OptionBar selectedOption={optionSelected}/>
                        </div>
                      </div>
            </div>
      </div>
    );
  } else {
    return(<Redirect to ="/" />);
    }
  }
}

// Estados del store
function mapStateToProps(state){
  return{
    isLogged: state.user.isLogged,
    nombreUser: state.user.nombreUser,
    tipoUser:  state.user.tipoUser,
    optionSelected: state.baroption.optionSelected
  }
}
function mapDispatchToProps(dispatch){
  return bindActionCreators ({
    cargarContenido
  },dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(TestWordPdf);
